import MattersTable from 'pages/matters/MattersTableWithFilters';
import OutBoundReferralsTable from 'pages/referrals/OutBoundReferalsTable';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { GroupMemberRoleType, PartyGroup } from 'types/groups';

const STACKED_TABLE_MAX_HEIGHT = 'max-h-[max(16rem,calc(100vh-24rem))]';

interface Props {
    partyGroup: PartyGroup;
}

const ReferralsView: React.FC<Props> = ({ partyGroup }) => {
    const partyIds = useMemo(() => {
        const ids = (partyGroup.parties || [])
            .filter((item) => item.groupMemberRoleTypeCode === GroupMemberRoleType.MEMBER)
            .map((item) => item.party.id);
        return ids.length ? ids : [0];
    }, [partyGroup.parties]);

    return (
        // No height, and a capped frame per table — see the contact page's referrals view.
        <div className="flex flex-col gap-8">
            <div>
                <h5 className="text-h5">
                    <FormattedMessage id="groups.clients-recommended" />
                </h5>
                <OutBoundReferralsTable
                    passiveFilter={`id=isoutboundreferral=(${partyIds.join(',')})`}
                    dataTableClassName={STACKED_TABLE_MAX_HEIGHT}
                />
            </div>
            <div>
                <h5 className="text-h5">
                    <FormattedMessage id="groups.cases-recommended" />
                </h5>
                <MattersTable
                    passiveFilter={`id=isreferredparty=(${partyIds})`}
                    disableExport
                    view="party-group-referrals"
                    dataTableClassName={STACKED_TABLE_MAX_HEIGHT}
                />
            </div>
        </div>
    );
};

export default ReferralsView;
